<template>
    <v-dialog max-width="600px" v-model="dialog">
        <!-- <v-btn flat slot="activator" color="primary">Add a quote or Excerpt</v-btn> -->
        <v-btn slot="activator" class="mx-2" flat fab>
        <v-icon dark>add</v-icon>
        </v-btn>
        <v-card>
            <v-card-title>
                <span class="headline font-weight-bold">Add a Foundational Detail:</span> 
                <!-- <v-alert
                :value="true"
                color="primary"
                icon="info"
                class="caption text-lg-justify"
                outline>
                You have seleect
              </v-alert>  -->
            </v-card-title>

            <v-card-text>
                <v-form class="px-3" ref="form">
                     
                     
                    <v-radio-group v-model="foundationaldetailtypedefault" label="This detail is a:" :mandatory="true" row>
                        <v-radio :label="foundationaldetailtype[0]" value="goal"></v-radio> 
                        <v-radio :label="foundationaldetailtype[1]" value="core competence"></v-radio>
                        <v-radio :label="foundationaldetailtype[2]" value="core cultural aspect"></v-radio>
                        </v-radio-group> 

                    <v-textarea outline :label="foundationdetaildescriptionLabeltext" v-model="foundationdetaildescription" :hint="foundationdetaildescriptionHint" :rules="textInputRules"></v-textarea>
                     
 
                    <!-- <v-btn flat color="primary" @click="submit" :loading="loading">Add Detail</v-btn>  -->
                    <v-btn flat color="primary" @click="dummySubmit" :loading="loading">Add Detail</v-btn> 
                    <!-- <v-btn flat to="/bifdashboard" color="primary" class="mx-2 mt-3" :loading="loading">Add Story</v-btn> -->
                    <v-btn flat @click="dialog = false">Cancel</v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import db from '../fb'
import gvars from '../globalvariables'

export default {
    name: '',
    data() {
        return{
            foundationdetaildescription: 'Onboard additional 10,000 active users per quater', 
            foundationdetaildescriptionLabeltext: 'Provide a description for this detail', 
            foundationdetaildescriptionHint: 'Please ensure that the appropriate type is selected before entering the description.', 
            
            
            foundationaldetailtypedefault: 'goal',
            foundationaldetailtype: ['goal', 'core competence', 'core cultural aspect'],
            textInputRules: [
                    v => !!v || 'This field is required',
                    v => v.length >= 3 || 'Minimum length is 3 characters'
                ],
            loading: false,
            dialog: false
        }
    },
    methods: {
        submit() {

             if(this.$refs.form.validate()) {
            //console.log(this.nameofthesolution, this.briefdescriptionofthesolution)
            this.loading = true;
             

            //details = {}

            const businessfoundationdetail = {
                foundationdetailtype: this.foundationaldetailtypedefault,
                foundationdetaildescription: this.foundationdetaildescription
            }

            //details['prefs'] = firstprefdetails;
 

            //
            //xuWrU7qOYXxLjL97QoCe

        var dbref = db.collection('projects').doc(this.getProjectID()).collection('businessfoundationdetails');

        dbref.add(businessfoundationdetail).then(() =>{
            //console.log('Collection quotes created')
                      this.loading = false;
          this.dialog = false;
          this.$emit('detailadded')
        });


    //     db.collection('projects').doc('Yx3r6dHUeFFdGvY6Acvy').collection('quotesregardingfirstprefsolutionconcept').update(quote).then(() => {
    //       //console.log("added to db!", docRef.id)
    //       this.loading = false;
    //       this.dialog = false;
    //       this.$emit('quoteconfirmed')
    //    });

             }
        },
        dummySubmit(){
            this.loading = false;
          this.dialog = false;

        },
    getProjectID(){
      return gvars.PROJECTID;
    } 
    }
}
</script>
